import { PriceAlertActivated } from '@eih-netbroker/common';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { priceAlertsAtom } from '../../../modules/trading/states/priceAlertsAtom';

export const useUserStreamPriceAlert = () => {
  const setPriceAlerts = useSetAtom(priceAlertsAtom);
  return useCallback(
    (priceAlertActivated: PriceAlertActivated) => {
      setPriceAlerts(prev => ({
        ...prev,
        priceAlerts: prev.priceAlerts.filter(priceAlert => priceAlert.id !== priceAlertActivated.id),
      }));
    },
    [setPriceAlerts],
  );
};
